import * as AppPics from 'assets/images';
import { Link } from 'react-router-dom';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
import { useState } from 'react';
import { notifier } from 'components/Toaster';
import useGetPodcastSupportList from 'hooks/API/GET/useGetPodcastSupportList';
import useDeletePodcastTicket from 'hooks/API/DELETE/useDeletePodcastTicket';

const actionsConfig = {
  open: false,
  data: {},
  Header: null,
  Body: null,
  isDeleteOperation: false,
};

function PodcastSupportList() {
  const [actions, setActions] = useState({ ...actionsConfig });

  const { data } = useGetPodcastSupportList({ enabled: true });
  const ticketData = data?.data?.data?.result;

  const { mutate: deleteMutation } = useDeletePodcastTicket();

  const handleDeleteTicket = (ticket) => {
    setActions({
      open: true,
      data: { ticketId: ticket.id },
      Header: 'Delete Ticket',
      Body: `Are you sure you want to delete the ticket?`,
      isDeleteOperation: true,
    });
  };

  const handleDeleteConfirm = () => {
    deleteMutation(actions.data.ticketId, {
      onSuccess: (res) => {
        notifier.success(res?.data?.message);
      },
      onError: (err) => {
        notifier.error(err?.response?.data?.data?.message);
      },
    });

    setActions({ ...actionsConfig });
  };

  return (
    <>
      <BasicDelete
        open={actions.open}
        closeModal={() => setActions({ ...actionsConfig })}
        Header={actions.Header}
        Body={actions.Body}
        handleConfirmation={handleDeleteConfirm}
      />

      <div className="mainWraper coursetabsection">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back">
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <AppBreadcrumbs
                links={[
                  { label: 'Dashboard', to: '/dashboard' },
                  { label: 'Podcast Home', to: '/podcast' },
                ]}
                current="Support"
              />
            </div>

            <div className="tab__content-actBody">
              <div className="px-5 py-5">
                <div className="tab__contentMenu">
                  <ul className="tab__contentMenu-list">
                    <li>
                      <h2 className="prime-head p-0 boldtitle text-nowrap">
                        Manage Podcast Support
                      </h2>
                    </li>
                  </ul>

                  <div className="mainHeader__search">
                    <ul className="tab__contentMenu-list">
                      <li className="relative">
                        <input
                          className="mainHeader__searchInput"
                          placeholder="Search Ticket..."
                          type="text"
                        />
                        <span className="mainHeader__searchBtn">
                          <img src={AppPics.TopMenuSearchSvg} alt="Search" />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="tab__contentBody">
                  <div className="tableWrap">
                    <div className="table-responsive">
                      <table className="table tableWrap__table">
                        <thead className="thead-light __appTheadColor">
                          <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">Reference No.</th>
                            <th className="text-center">Name</th>
                            <th className="text-center">Contact Info</th>
                            <th className="text-center">Issue Type</th>
                            <th className="text-center">Date</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {ticketData?.length > 0 ? (
                            ticketData.map((item, index) => (
                              <tr key={item?.id}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{item?.referenceNo}</td>
                                <td className="text-center">{item?.userId?.name}</td>
                                <td className="text-center">
                                  {item?.userId?.mobilFull
                                    ? item?.userId?.mobilFull
                                    : item?.userId?.email}
                                </td>
                                <td className="text-center">{item?.issueCategory}</td>
                                <td className="text-center">
                                  {new Date(item?.createdAt).toLocaleDateString()}
                                </td>

                                <td className="text-center">
                                  <Link
                                    className="actions-icons mx-2 text-primary"
                                    title="View Details"
                                    to={`/support/podcast/${item?.id}`}
                                  >
                                    <img src={AppPics.EpisodePng} alt="View Ticket" />
                                  </Link>

                                  <button
                                    className="actions-icons mx-2 text-danger"
                                    title="Close Ticket"
                                    onClick={() => handleDeleteTicket(item)}
                                  >
                                    <img src={AppPics.DeleteSvg} alt="Close" />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={6} className="text-center py-4">
                                No Data
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PodcastSupportList;
